import React, { useCallback, useEffect, useState } from "react";
import BaseCard from "../components/BaseCard";
import styles from "./index.module.less";
import IconFont from "@/components/icon";

interface IProps {
  onManageCard: () => void;
}

function AddCard({ onManageCard }: IProps) {
  return (
    <BaseCard className={styles["content"]} onClick={onManageCard}>
      <div className={styles["manage_card"]}>
        <IconFont type="iconic_pc_guanlikapian" style={{ fontSize: "15px", marginRight: "5px" }} />
        管理卡片
      </div>
    </BaseCard>
  );
}

export default AddCard;
